import { trackPromise } from 'react-promise-tracker';
import Cookies from 'universal-cookie';
// import errorHandler from '../hoc/errorHandler';
const cookies = new Cookies();

export const FetchAPI = async (url, header,signal) => {
    const response = await trackPromise(fetch(url, {
        signal,
        method: 'GET',
        headers:  ( header != undefined ) ?  header : { clientToken: cookies.get('clientToken'),'Cache-Control': 'no-cache' },
    })).then(function (res) {
        // if(res.status == 200){
            return res;
        // }else{
        //     const ErrRes = {status: res.status, message: 'Oops..! Something went wrong.' }
        //     return ErrRes;
        // }
    }).catch(function(error){
        const res = {status: (error.response === undefined) ?  400 :error.response.status, message: 'Oops..! Something went wrong.' }
        return res;
    });
    
    /*
    const response =  await trackPromise(axios({
        method: 'GET',
        url: url,
        headers : ( header != undefined ) ?  header : { clientToken: cookies.get('clientToken') }
      }).then(function (res) {

          return res;
      }).catch(function(error){
          const res = {status: error.response.status, message: 'Oops..! Something went wrong.' }
          return res;
      }));
    */
    return response;
}